<template>
    <DCard
        padding
    >
        <DTable
            :items="creditNoteTypes"
            :fields="getFields"
            hover
            sorter
        >
            <template #cost_center="{item}">
                <td>
                    {{ item.cost_center !== null ? item.cost_center : '' }}
                </td>
            </template>
            <template #text="{item}">
                <td>
                    {{ item.text !== null ? item.text : '' }}
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DButton
                            :id="`edit_${item.id}`"
                            mini
                            icon="pencil"
                            @click="editCreditNoteType(item.id)"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="isInLoadingState || isPartner(item)"
                            @click="deleteCreditNoteType(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.credit_note_types.index.add_credit_note_type_button')"
                @click="createCreditNoteType"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.credit_note_types.index.delete_confirm_modal.title')"
            :message="__('settings.credit_note_types.index.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script>
export default {
    name: 'CreditNoteTypesIndex',
    props: {
        creditNoteTypes: {
            type: Array,
            default: () => { return [] }
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            deleteCallBack: () => { return {} }
        }
    },
    computed: {
        getFields () {
            if (this.isFinanceSystemNetsuite === true) {
                return [
                    { key: 'id', label: this.__('settings.credit_note_types.index.table.headers.id'), _classes: 'sorter-name' },
                    { key: 'name', label: this.__('settings.credit_note_types.index.table.headers.name'), _classes: 'sorter-name' },
                    { key: 'title', label: this.__('settings.credit_note_types.index.table.headers.title'), _classes: 'sorter-title' },
                    { key: 'netsuite_item_id', label: this.__('settings.credit_note_types.index.table.headers.netsuite_item_id'), _classes: 'sorter-netsuite-item-id' },
                    { key: 'netsuite_department_id', label: this.__('settings.credit_note_types.index.table.headers.netsuite_department_id'), _classes: 'sorter-netsuite-department-id' },
                    { key: 'text', label: this.__('settings.credit_note_types.index.table.headers.text'), _classes: 'sorter-text' },
                    { key: 'actions', label: '', sorter: false, filter: false }
                ]
            }

            return [
                { key: 'id', label: this.__('settings.credit_note_types.index.table.headers.id'), _classes: 'sorter-name' },
                { key: 'name', label: this.__('settings.credit_note_types.index.table.headers.name'), _classes: 'sorter-name' },
                { key: 'title', label: this.__('settings.credit_note_types.index.table.headers.title'), _classes: 'sorter-title' },
                { key: 'cost_center', label: this.__('settings.credit_note_types.index.table.headers.cost_center'), _classes: 'sorter-cost-center' },
                { key: 'text', label: this.__('settings.credit_note_types.index.table.headers.text'), _classes: 'sorter-text' },
                { key: 'actions', label: '', sorter: false, filter: false }
            ]
        }
    },
    methods: {
        createCreditNoteType () {
            return this.$inertia.get(this.$route('settings.credit-note-types.create'))
        },
        editCreditNoteType (id) {
            return this.$inertia.get(this.$route('settings.credit-note-types.edit', { credit_note_type: id }))
        },
        deleteCreditNoteType (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('settings.credit-note-types.destroy', { credit_note_type: id }))
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        isPartner (item) {
            return !!item.credit_note_type_partner.length
        }
    }
}
</script>
